module.exports = __webpack_public_path__ + "static/media/bulk_upload_fleet_performance.666bd60a.csv";